import React, { useState } from 'react';
import Icon from '../../../components/appIcon';
import Image from '../../../components/appImage';
import Button from '../../../components/ui/button';

const BACKEND_URL = import.meta.env.VITE_API_URL;
const ProfileCard = ({ employee }) => {

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 enterprise-shadow-card">
      <div className="text-center mb-6">
        <div className="relative inline-block mb-4">
          <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-border">
            <Image
              src={employee?.images?.[0]
                ? `${BACKEND_URL}${employee?.images[0]}`
                : `https://via.placeholder.com/150?text=Profile`}
              alt={`${employee?.first_name} ${employee?.last_name}`}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success border-2 border-card rounded-full flex items-center justify-center">
            <Icon name="Check" size={12} color="white" />
          </div>
        </div>

        <h3 className="text-lg font-semibold text-foreground mb-1">
          {employee?.first_name} {employee?.last_name}
        </h3>
        <p className="text-sm text-muted-foreground mb-1">{employee?.position}</p>
        <p className="text-xs text-muted-foreground font-mono">{employee?.employee_id}</p>

        <div className="flex items-center justify-center space-x-2 mt-3">
          <div className={`w-2 h-2 rounded-full ${employee?.status === 'active' ? 'bg-success' : 'bg-error'}`}></div>
          <span className="text-xs text-muted-foreground capitalize">{employee?.status}</span>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-center space-x-3 text-sm">
          <Icon name="Mail" size={16} className="text-muted-foreground" />
          <span className="text-foreground truncate">{employee?.email}</span>
        </div>

        <div className="flex items-center space-x-3 text-sm">
          <Icon name="Phone" size={16} className="text-muted-foreground" />
          <span className="text-foreground">{employee?.phone_number}</span>
        </div>

        <div className="flex items-center space-x-3 text-sm">
          <Icon name="Building" size={16} className="text-muted-foreground" />
          <span className="text-foreground">{employee?.department}</span>
        </div>

        <div className="flex items-center space-x-3 text-sm">
          <Icon name="Calendar" size={16} className="text-muted-foreground" />
          <span className="text-foreground">
            Joined {new Date(employee?.created_at)?.toLocaleDateString('en-US', {
              month: 'short',
              year: 'numeric'
            })}
          </span>
        </div>

        {isExpanded && (
          <div className="pt-4 border-t border-border space-y-4">
            <div className="flex items-center space-x-3 text-sm">
              <Icon name="MapPin" size={16} className="text-muted-foreground" />
              <span className="text-foreground">{employee?.address}</span>
            </div>

            <div className="flex items-center space-x-3 text-sm">
              <Icon name="User" size={16} className="text-muted-foreground" />
              <span className="text-foreground capitalize">{employee?.employee_type}</span>
            </div>
          </div>
        )}
      </div>
      <div className="mt-6 space-y-3">
        <Button
          variant="ghost"
          fullWidth
          onClick={toggleExpanded}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
          iconSize={16}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </Button>
      </div>
    </div>
  );
};

export default ProfileCard;